export default "__VITE_ASSET__DV71SiSx__"